<template>
  <div class="bg-gray-600 text-white rounded-xl p-6">
    <div>
      {{ message }}
    </div>
    <div v-if="type === 'confirm'" class="flex flex-row justify-center mt-7 space-x-2">
      <BaseButton
        class="dialog-button bg-gray-500 w-28 py-1"
        @click="cancel"
      >
        キャンセル
      </BaseButton>
      <BaseButton
        class="dialog-button bg-pink-600 w-28 py-1"
        @click="ok"
      >
        OK
      </BaseButton>
    </div>
    <div v-if="type === 'alert'" class="flex flex-row justify-center mt-7">
      <BaseButton
        class="dialog-button bg-gray-500 min-w-20 py-1 px-16"
        @click="ok"
      >
        OK
      </BaseButton>
    </div>
  </div>
</template>

<script lang="ts">
import noop from 'lodash/noop';
import { defineComponent, PropType } from 'vue';

import { PopupDialogType } from '@/hooks/use_popup_dialog';

import BaseButton from './BaseButton.vue';

export default defineComponent({
  name: 'MessageCard',
  components: { BaseButton },
  props: {

    /**
     * ダイアログに表示するメッセージ
     */
    message: {
      type: String,
      default: '',
    },

    /**
     * ダイアログのタイプ
     * alert: OKボタンのみ表示
     * confirm: OKボタンとキャンセルボタンを表示
     */
    type: {
      type: String as PropType<PopupDialogType>,
      default: 'alert',
    },

    /**
     * OKボタンのアクション
     */
    ok: {
      type: Function as PropType<() => void>,
      default: () => noop,
    },

    /**
     * キャンセルボタンのアクション
     */
    cancel: {
      type: Function as PropType<() => void>,
      default: () => noop,
    },
  },
});
</script>
